<div class="p-4 md:p-5 border-b">
  <h2 class="text-xl font-semibold text-gray-900 dark:text-white">{{ data.title | translate }}</h2>
</div>

<div class="grid gap-4 p-4">
  <span class="text-black py-4">{{ data.message | translate }}</span>

  <div class="flex gap-4">
    <app-flowbite-button [mat-dialog-close]="false" color="light" size="sm">{{
      data.cancelButtonLabel || 'common.button.cancel' | translate
    }}</app-flowbite-button>
    <app-flowbite-button [mat-dialog-close]="true" size="sm">{{
      data.confirmButtonLabel || 'common.button.confirm' | translate
    }}</app-flowbite-button>
  </div>
</div>
